import React from 'react'
import { SoldOutBanner } from '@moonpig/web-shared-products'
import { Box } from '@moonpig/launchpad-components'
import { styled, breakpoint } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'
import {
  AddToBasketCTAModule,
  GiftImageCarouselModule,
  PriceModule,
  ProductTitleModule,
  RatingModule,
  VariantSelectorModule,
  ThingsToKnowModule,
  PeopleAlsoViewedModule,
  BreadcrumbsModule,
  ProductPillsModule,
  DispatchCutOffBannerModule,
  OfferBannerModule,
  ProductSchemaModule,
  QuantitySelectorModule,
  ProductUpsellModule,
  AddOnSelectorModule,
  KlarnaInfoModule,
  USPModule,
} from '../../../modules'
import { ModularLayout } from '../types'
import { SoldOutWrapper } from '../../SoldOutWrapper'

const StyledAddToBasketCTAModule = styled(AddToBasketCTAModule)`
  ${breakpoint('md')} {
    position: sticky;
    bottom: 0;
    z-index: 1;
    padding: ${spacingPx(10)} 0;
    box-shadow: -4px 0 0 0 #fff, 4px 0 0 0 #fff;
    background: linear-gradient(
      to top,
      rgba(255, 255, 255, 1) 80%,
      rgba(255, 255, 255, 0.1)
    );
  }
`

const sharedBottomSection = [
  <ThingsToKnowModule
    key="things-to-know-module"
    mt={{ xs: 10, md: 11 }}
    pb={{ xs: 6, md: 10, lg: 12, xl: 15 }}
    withContainer
  />,
  <PeopleAlsoViewedModule
    key="people-also-viewed-module"
    withContainer
    pt={{ xs: 8, lg: 5 }}
    pb={13}
    bgcolor="colorBackground02"
    borderBottom={1}
    borderColor="colorBlack30"
  />,
  <ProductSchemaModule key="product-offer-schema-module" />,
]

export const giftAndFlowers: ModularLayout = {
  top: [
    <OfferBannerModule key="offer-banner-module" />,
    <BreadcrumbsModule withContainer key="breadcrumbs-module" />,
  ],
  middleLeft: [<GiftImageCarouselModule key="gift-image-carousel" />],
  middleRight: [
    <ProductTitleModule key="product-title-module" mt={{ xs: 6, md: 0 }} />,
    <RatingModule key="rating-module" mt={{ xs: 6, md: 4 }} />,
    <PriceModule key="price-module" mt={6} />,
    <ProductPillsModule key="product-pills-module" mt={6} />,
    <USPModule key="product-usp-module" mt={6} />,
    <KlarnaInfoModule key="klarna-info-module" mt={6} />,
    <DispatchCutOffBannerModule key="dispatch-cut-off-banner-module" mt={6} />,
    <ProductUpsellModule key="product-upsell-module" mt={6} />,
    <VariantSelectorModule key="variant-selector-module" mt={8} />,
    <AddOnSelectorModule key="add-on-selector-module" mt={8} />,
    <QuantitySelectorModule key="quantity-selector-module" mt={8} />,
    <StyledAddToBasketCTAModule key="add-to-basket-cta-module" />,
  ],
  bottom: sharedBottomSection,
}

export const giftAndFlowersOutOfStock: ModularLayout = {
  top: [
    <OfferBannerModule key="offer-banner-module" />,
    <BreadcrumbsModule withContainer key="breadcrumbs-module" />,
  ],
  middleLeft: [
    <SoldOutWrapper key="sold-out-gift-image-carousel">
      <GiftImageCarouselModule />
    </SoldOutWrapper>,
  ],
  middleRight: [
    <ProductTitleModule key="product-title-module" mt={{ xs: 6, md: 3 }} />,
    <RatingModule key="rating-module" mt={{ xs: 6, md: 4 }} />,
    <ProductPillsModule key="product-pills-module" mt={{ xs: 6, md: 8 }} />,
    <Box key="sold-out-banner" mt={8}>
      <SoldOutBanner />
    </Box>,
  ],
  bottom: sharedBottomSection,
}
